import { IReorderWebsitesDTO, IWebsites } from '@/models/websites.model';

export class ReorderWebsitesDTO implements IReorderWebsitesDTO {
  items: { id?: string; position?: number }[];

  showcaseChannelId: number;

  constructor(items: IWebsites[], showcaseChannelId: number) {
    this.items = items.map((website) => ({ id: website.id, position: website.position }));
    this.showcaseChannelId = showcaseChannelId;
  }
}
